<template>
  <v-app>
    <app-sidebar style="z-index: 200"></app-sidebar>
    <app-header style="z-index: 100"></app-header>
    <v-main class="app-content pb-10 pt-0 mt-0">
      <!-- <div class=" bg-success"> -->
      <div class="ml-0 absolute" style="z-index: 10;">
        <v-breadcrumbs :items="breadcrumbItems">
          <template v-slot:item="{ item }">
            <v-breadcrumbs-item
              :disabled="item.disabled"
              :exact="item.exact"
              :to="item.to"
            >
              <span :class="!item.disabled && 'meteor-primary'">{{
                item.text
              }}</span>
            </v-breadcrumbs-item>
          </template>
          <template v-slot:divider>
            <v-icon>mdi-chevron-right</v-icon>
          </template>
        </v-breadcrumbs>
      </div>
      <div class="mb-10" transition="fade">
        <transition name="fade">
          <router-view></router-view>
        </transition>
      </div>
      <!-- </div> -->
    </v-main>
    <v-footer>
      <v-bottom-navigation v-model="bottomNav" fixed color="teal" class="mt-5">
        <v-btn value="Home" @click="goTo('/dashboard')">
          <span>Home</span>
          <v-icon>mdi-home</v-icon>
        </v-btn>
        <v-btn value="Employee" @click="goTo('/employee')">
          <span>Employee</span>
          <v-icon>mdi-briefcase</v-icon>
        </v-btn>
        <v-btn value="Setting Profile" @click="goTo('/setting/profile/')">
          <span>Profile</span>
          <v-icon>mdi-account</v-icon>
        </v-btn>

        <v-btn value="Address" @click="goTo('/setting/password/')">
          <span>Password</span>
          <v-icon>mdi-key</v-icon>
        </v-btn>
      </v-bottom-navigation>
    </v-footer>
  </v-app>
</template>

<script>
import AppHeader from "@/components/AppHeader";
import AppSidebar from "@/components/AppSidebar";
export default {
  name: "AppHomeLayout",
  components: {
    AppSidebar,
    AppHeader
  },
  data() {
    return {
      bottomNav: null
    };
  },
  computed: {
    breadcrumbItems() {
      const isLength = this.$route.matched.length > 0;
      if (isLength) {
        const breadcrumbArr = [...this.$route.matched];
        let currentBreadcrumbValue = null;
        const breadcrumbComponent = breadcrumbArr.map(item => {
          if (item.name === currentBreadcrumbValue) {
            return false;
          } else {
            currentBreadcrumbValue = item.name;
            return {
              text: item.name,
              to: item.path,
              exact: true,
              disabled: this.$route.name === item.name
            };
          }
        });
        return breadcrumbComponent.filter(item => item);
      } else {
        return [];
      }
    }
  },
  mounted() {},
  created() {
    if (this.$workbox) {
      this.$workbox.addEventListener("waiting", () => {
        this.showUpgradeUI = true;
      });
    }
  },
  methods: {
    async accept() {
      this.showUpgradeUI = false;
      await this.$workbox.messageSW({ type: "SKIP_WAITING" });
    },
    goTo(item) {
      this.$router.push(item);
    }
  }
};
</script>

<style lang="scss" scoped>
.app-content {
  position: relative;
  min-height: 100vh;
  background-color: #f4f5f6;
}
.bg-color {
  background-color: #e5e5e5 !important;
  min-height: 100vh;
}
.meteor-primary {
  color: #008ef8 !important;
}
</style>
